var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_70_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 21C2 9.95431 10.9543 1 22 1C33.0457 1 42 9.95431 42 21C42 32.0457 33.0457 41 22 41C10.9543 41 2 32.0457 2 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21C2.5 10.2304 11.2304 1.5 22 1.5C32.7696 1.5 41.5 10.2304 41.5 21C41.5 31.7696 32.7696 40.5 22 40.5C11.2304 40.5 2.5 31.7696 2.5 21Z",
    stroke: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 28.2H31V30H13V28.2ZM14.8 21H16.6V27.3H14.8V21ZM19.3 21H21.1V27.3H19.3V21ZM22.9 21H24.7V27.3H22.9V21ZM27.4 21H29.2V27.3H27.4V21ZM13 16.5L22 12L31 16.5V20.1H13V16.5ZM22 17.4C22.2387 17.4 22.4676 17.3052 22.6364 17.1364C22.8052 16.9676 22.9 16.7387 22.9 16.5C22.9 16.2613 22.8052 16.0324 22.6364 15.8636C22.4676 15.6948 22.2387 15.6 22 15.6C21.7613 15.6 21.5324 15.6948 21.3636 15.8636C21.1948 16.0324 21.1 16.2613 21.1 16.5C21.1 16.7387 21.1948 16.9676 21.3636 17.1364C21.5324 17.3052 21.7613 17.4 22 17.4Z",
    fill: "#0E121B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_70_688",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_70_688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_70_688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/BankTransfer.eeb4fdf5f58469787924ff5c70c6cc7c.svg";
export { ForwardRef as ReactComponent };